import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_GROUP_URL } from '../../connection.data';

@Injectable()
export class GroupService extends BasicService {

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_GROUP_URL;
    }
}